<template>
  <RouterLink :to="to" class="nav-item" :class="{ active: isActive }">
    <span class="icon">
      <font-awesome-icon :icon="icon" />
    </span>
    <span class="label">{{ label }}</span>
  </RouterLink>
</template>

<script>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
  name: 'NavigationItem',
  props: {
    to: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const route = useRoute();

    const isActive = computed(() => {
      return route.path.startsWith(props.to);
    });

    return {
      isActive
    };
  }
};
</script>

<style scoped>
.nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin: 0.25rem 0.5rem;
  text-decoration: none;
  color: var(--al-text);
  font-weight: 500;
  border-radius: 0.5rem;
  transition: all 0.2s;
  width: calc(100% - 1rem);
  background-color: var(--al-surface-raised);
  border: 1px solid var(--al-border);
  box-shadow: var(--al-shadow-sm);
}

.nav-item:hover {
  background-color: var(--al-surface-sunken);
  /* AA: primary blue on the sunken fill is ~3.2:1; the bg change carries the
     hover affordance, so text stays at full contrast. */
  color: var(--al-text);
  box-shadow: var(--al-shadow-sm);
  border-color: var(--al-border);
}

.nav-item.active {
  background-color: var(--al-primary-soft);
  color: var(--al-primary);
  font-weight: 600;
  border-left: 3px solid var(--al-primary);
  box-shadow: var(--al-shadow-sm);
}

.icon {
  margin-right: 0.75rem;
  width: 1.5rem;
  text-align: center;
}

/* For parent with collapsed class */
:deep(.collapsed) .nav-item {
  justify-content: center;
  padding: 0.75rem 0;
  margin: 0.25rem auto;
  width: 80%;
  background-color: var(--al-surface-raised);
}

:deep(.collapsed) .nav-item:hover {
  background-color: var(--al-surface-sunken);
  transform: translateY(-1px);
}

:deep(.collapsed) .nav-item.active {
  background-color: var(--al-primary-soft);
  border-left: none;
  border-top: 2px solid var(--al-primary);
}

:deep(.collapsed) .icon {
  margin-right: 0;
}

.label {
  font-size: 1rem;
  font-weight: 500;
}
</style>